<div class="content">
  <form class="treatment-form" [formGroup]="operationHistoryForm" (submit)="addToList()">
    <mat-form-field>
      <mat-label>{{ 'operation' | translate }}</mat-label>
      <input matInput type="text" name="operation" formControlName="operation" gcFormField gcFormFieldNoError />
    </mat-form-field>
    <mat-form-field class="date-field">
      <mat-label>{{ 'date' | translate }}</mat-label>
      <input matInput type="text" autocomplete="off" [matDatepicker]="startpicker" formControlName="date" (focus)="startpicker.open()" />
      <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
      <mat-datepicker #startpicker></mat-datepicker>
      <mat-error *ngIf="checkDateValid(operationHistoryForm.controls.date)">{{ 'this_date_is_invalid' | translate }}</mat-error>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'doctor' | translate }}</mat-label>
      <input matInput type="text" name="doctor" formControlName="doctor" gcFormField gcFormFieldNoError />
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'hospital' | translate }}</mat-label>
      <input matInput type="text" name="hospital" formControlName="hospital" gcFormField gcFormFieldNoError />
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'note' | translate }}</mat-label>
      <input matInput type="text" name="note" formControlName="note" gcFormField gcFormFieldNoError />
    </mat-form-field>
    <button mat-flat-button type="submit" class="add-button" [disabled]="operationHistoryForm.invalid">
      <mat-icon svgIcon="plus"></mat-icon>
      {{ 'add_operation' | translate }}
    </button>
    <div class="divider"></div>
  </form>
  <div *ngIf="historyListForm">
    <form [formGroup]="historyListForm">
      <div class="treatments-display">
        <mat-accordion multi="true" formArrayName="rowList">
          <mat-expansion-panel
            class="treatment-line"
            *ngFor="let row of rowListControl.controls; let i = index"
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = false"
            [formGroupName]="i"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ 'date_label' | translate: { value: (row.get('date').value | customDate: 'dd LLLL yyyy') } }}
              </mat-panel-title>
              <mat-panel-description *ngIf="(isMobile$ | async) === false">
                {{ 'operation_label' | translate: { value: row.get('operation').value } }}
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="panel-content">
              <mat-form-field>
                <mat-label>{{ 'operation' | translate }}</mat-label>
                <input matInput type="text" name="operation" formControlName="operation" gcFormField gcFormFieldNoError />
              </mat-form-field>
              <mat-form-field class="date-field">
                <mat-label>{{ 'date' | translate }}</mat-label>
                <input
                  matInput
                  type="text"
                  autocomplete="off"
                  [matDatepicker]="startpicker"
                  formControlName="date"
                  (focus)="startpicker.open()"
                />
                <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
                <mat-datepicker #startpicker></mat-datepicker>
                <mat-error *ngIf="checkDateValid(row.controls.date)">{{ 'this_date_is_invalid' | translate }}</mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ 'doctor' | translate }}</mat-label>
                <input matInput type="text" name="doctor" formControlName="doctor" gcFormField gcFormFieldNoError />
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ 'hospital' | translate }}</mat-label>
                <input matInput type="text" name="hospital" formControlName="hospital" gcFormField gcFormFieldNoError />
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ 'note' | translate }}</mat-label>
                <input matInput type="text" name="note" formControlName="note" gcFormField gcFormFieldNoError />
              </mat-form-field>
            </div>
            <div class="delete-button">
              <button mat-raised-button color="warn" class="delete-button" (click)="deleteRow(i)">
                <mat-icon svgIcon="delete"></mat-icon>
                {{ 'delete' | translate }}
              </button>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </form>
  </div>
  <div class="button-div">
    <button
      mat-flat-button
      [ngClass]="{ primary: requestUuid === null, accent: requestUuid !== null }"
      class="save-button"
      (click)="submit()"
    >
      <mat-icon svgIcon="check"></mat-icon>
      {{ 'save_operation' | translate }}
    </button>
  </div>
</div>
